import { useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslate } from '@repo/unicity'
import { LoginModal } from './login-modal.component'

/**
 * Banner that offers existing members a shortcut to open the login modal.
 *
 * Self-contained: owns its own modal state so it can be dropped anywhere
 * (checkout pages, landing sections, etc.) without prop plumbing.
 */
const LoginBar = ({ onLoginSuccess }: { onLoginSuccess?: () => void } = {}) => {
    const { translate } = useTranslate()
    const [open, setOpen] = useState(false)

    return (
        <>
            <Box
                onClick={() => setOpen(true)}
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    px: '30px',
                    py: '20px',
                    borderRadius: '12px',
                    border: '1px solid rgba(153, 188, 223, 0.35)',
                    backgroundColor: 'rgb(233, 241, 250)',
                    cursor: 'pointer'
                }}
                data-testid="login-bar-box-typography-already-have-an-account">
                <Typography variant="body2" sx={{ fontSize: 14, fontWeight: 500, color: '#003764' }} data-testid="login-bar-typography-already-have-an-account">
                    {translate('Already_have_an_account')}
                </Typography>
                <Typography
                    variant="body2"
                    sx={{ fontSize: 14, fontWeight: 400, color: '#003764', textDecoration: 'underline' }}
                    data-testid="login-bar-typography-login">
                    {translate('login')}
                </Typography>
            </Box>
            <LoginModal open={open} onClose={() => setOpen(false)} onSuccess={onLoginSuccess} data-testid="login-bar-login-modal" />
        </>
    )
}

export { LoginBar }
export default LoginBar
